<div class="my-4">
  @if (!data) {
  <div class="p-4">Loading...please wait</div>
  } @else {
  <p-tabs [value]="tabs[0]?.name">
    <p-tablist>
      @for (tab of tabs; track tab.name) {
      <p-tab [value]="tab.name">{{ tab.name }}</p-tab>
      }
    </p-tablist>
    <p-tabpanels class="border border-neutral-400 my-4">
      @for (tab of tabs; track tab.name) {
      <p-tabpanel [value]="tab.name">
        @switch (tab.templateKey) { @case ('keyValue') {
        <ng-container [ngTemplateOutlet]="keyValue" [ngTemplateOutletContext]="{ $implicit: data[tab.dataKey] }" />
        } @case ('treeList') {
        <ng-container [ngTemplateOutlet]="treeList" [ngTemplateOutletContext]="{ $implicit: data[tab.dataKey] }" />
        } @case ('error') {
        {{ data.error }}
        } } @if (!data[tab.dataKey]) {
        <div>No data available</div>
        }
      </p-tabpanel>
      }
    </p-tabpanels>
  </p-tabs>
  }
</div>

<!-- tabs templates -->
<ng-template #keyValue let-data>
  <dl class="grid-list">
    @for (item of data | keyvalue; track item) {
    <dt>{{ item.key }}:</dt>
    @if ((item.value | keyvalue) && !item.value.length) {
    <dl class="grid-list">
      @for (record of item.value | keyvalue; track record) {
      <dt>{{ record.key | titleCase }}:</dt>
      <dd>{{ record.value | join : ', ' }}</dd>
      }
    </dl>
    } @else {
    <dd>{{ item.value | join : ', ' }}</dd>
    } }
  </dl>
</ng-template>

<ng-template #treeList let-data>
  <ul class="tree-list">
    @for (item of data | keyvalue; track item) {
    <li>
      <div class="cursor-pointer" (click)="item.expanded = !item.expanded">
        <i [ngClass]="item.expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></i>
        {{ item.key }}
      </div>
      @if (item.expanded) {
      <ul>
        @for (i of item.value | keyvalue; track i) {
        <li>
          <b tooltipPosition="top" [title]="i.key">{{ i.value }}</b>
        </li>
        }
      </ul>
      }
    </li>
    }
  </ul>
</ng-template>
